import React from 'react';

const Certified_Lab_Report = () => {
  return (
    <>
      <section
        className="lab-info-box"
        style={{ marginBottom: '10px' }}
      >
        <div className="info-card new-style" style={{boxShadow: '1px 2px 15px #c5c5c5'}}>
          <h2 style={{ color: '#000' }}>Certified Lab Report</h2>
          <p className="desc">
            Every batch is tested for purity, quality, and nutritional accuracy. Report values may
            vary (±5%) depending on testing conditions.
          </p>

          <div className="new-features">
            <div className="new-feature">
              <div className="icon-circle">
                <i className="fa-solid fa-shield-alt"></i>
              </div>
              <h5 style={{ color: '#000' }}>Authenticity Verified</h5>
              <p>Guaranteed genuine & certified quality.</p>
            </div>

            <div className="new-feature">
              <div className="icon-circle">
                <i className="fa-solid fa-flask"></i>
              </div>
              <h5 style={{ color: '#000' }}>Lab Tested</h5>
              <p>Each batch tested for protein purity.</p>
            </div>

            <div className="new-feature">
              <div className="icon-circle">
                <i className="fa-solid fa-leaf"></i>
              </div>
              <h5 style={{ color: '#000' }}>Clean Sourcing</h5>
              <p>Ingredients sourced responsibly.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Certified_Lab_Report;
